'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _generateIdForFile = require('../util/generateIdForFile');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUploadRecord = function (_Record) {
  _inherits(FileUploadRecord, _Record);

  function FileUploadRecord() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FileUploadRecord);

    return _possibleConstructorReturn(this, (FileUploadRecord.__proto__ || Object.getPrototypeOf(FileUploadRecord)).call(this, _extends({}, properties, {
      localId: (0, _generateIdForFile.generateIdForFile)({
        file: properties.file,
        timestamp: Date.now()
      })
    })));
  }

  return FileUploadRecord;
}((0, _immutable.Record)({
  file: null,
  localId: '',
  fileId: -1,
  uploadProgress: 0
}));

exports.default = FileUploadRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/file-upload/records/FileUploadRecord.js
// module id = 553
// module chunks = 2 3